import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onBeforeUnmount, watch } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import WidgetBaseComponent from '@/components/widgets/WidgetBaseComponent.vue'
import { Icons } from '@/icons/icons'
import { ContextName } from '@/store/types/storeGlobalTypes'
import { CustomDialogComponentName } from '@/store/modules/dialog/dialogTypes'
import usePermissions from '@/composables/usePermissions'
import LfWhiteCounterComponent from '@/components/counters/LfWhiteCounterComponent.vue'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'
import useSelectedRegister from '@/composables/useSelectedRegister'
import useStage from '@/composables/useStage'
import useEntity from '@/composables/useEntity'
import useEndpoints from '@/composables/useEndpoints'
import useGlobalVisionWidgets from '@/components/expedients/ExpedientCourts/composables/useGlobalVisionWidgets'
import useCustomDialog from '@/composables/useCustomDialog'

// COMPOSABLES

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpedientProfitabilityWidget',
  setup(__props) {

const { userHasPermissionToInvoiceAtLeastOneInvoiceType } = usePermissions()

// TRANSLATIONS
const { t } = useI18n()
const texts = {
  details: t('components.widgets.global_vision_profitability.details'),
  tooltip: t('components.tooltip.profitability_global_vision_warning')
}

// CONSTANTS
const contexts = {
  profitabilityContext: ContextName.EXPEDIENT_GLOBAL_VISION_PROFITABILITY,
  expedientContext: ContextName.EXPEDIENTS
}

const icons = {
  tooltip: Icons.INFO_FULL,
  visibleIcon: Icons.VISIBLE,
  openWindow: Icons.OPEN_WINDOW
}

// DATA
const showSpinner = ref(true)

// COMPOSABLES
const expedientRegister = useSelectedRegister({ entityName: contexts.expedientContext })
const profitabilityInfo = useSelectedRegister({ entityName: contexts.profitabilityContext })
const { selectedRegisterId: selectedExpedientId, loadSelectedRegisterWithPost } = expedientRegister
const { selectedRegisterData, removeSelectedRegisterDataContext } = profitabilityInfo

const { expedientStage } = useStage()
const { getEntity } = useEntity({ entityName: contexts.expedientContext })
const { getEndpoints } = useEndpoints()
const { fetchExpedientProfitabilityDetail, resetExpedientProfitabilityDetail } = useGlobalVisionWidgets()
const { showCustomDialog } = useCustomDialog()

// COMPUTED
const selectedExpedientProfitabilityInfo = computed(
  () => selectedRegisterData.value?.globalVisionExpProfitability || {}
)

const renderWidget = computed(() => !!selectedExpedientProfitabilityInfo.value)

const title = computed(() => selectedExpedientProfitabilityInfo.value.title)

const counters = computed(() => selectedExpedientProfitabilityInfo.value.counters)

const expedientStageStateGetter = computed(() => expedientStage.value)

const fetchGlobalVisionProfitabilityInfo = async () => {
  showSpinner.value = true

  const entity = getEntity()
  const entityType = entity.type
  const endpoints = getEndpoints(entityType)
  const endpoint = endpoints.get

  await loadSelectedRegisterWithPost({
    endpoint,
    context: contexts.profitabilityContext,
    post: {
      idExpedient: selectedExpedientId.value,
      source: contexts.profitabilityContext,
      idStage: expedientStageStateGetter.value
    }
  })

  showSpinner.value = false
}

const launchDialog = () => {
  showCustomDialog(CustomDialogComponentName.GLOBAL_VISION_PROFITABILITY, {
    maxWidth: '940px',
    minHeight: '200px'
  })
}

function init() {
  fetchExpedientProfitabilityDetail(selectedExpedientId.value)
  fetchGlobalVisionProfitabilityInfo()
}

// WATCHERS
watch(expedientStageStateGetter, () => {
  fetchGlobalVisionProfitabilityInfo()
})

// HOOKS
onBeforeUnmount(() => {
  removeSelectedRegisterDataContext()
  resetExpedientProfitabilityDetail()
})

// INIT
init()

return { __sfc: true,userHasPermissionToInvoiceAtLeastOneInvoiceType, t, texts, contexts, icons, showSpinner, expedientRegister, profitabilityInfo, selectedExpedientId, loadSelectedRegisterWithPost, selectedRegisterData, removeSelectedRegisterDataContext, expedientStage, getEntity, getEndpoints, fetchExpedientProfitabilityDetail, resetExpedientProfitabilityDetail, showCustomDialog, selectedExpedientProfitabilityInfo, renderWidget, title, counters, expedientStageStateGetter, fetchGlobalVisionProfitabilityInfo, launchDialog, init, WidgetBaseComponent, LfWhiteCounterComponent, LexonTooltipComponent }
}

})